import { render, staticRenderFns } from "./RecordPlay.vue?vue&type=template&id=6fb6ae5e&scoped=true&"
import script from "./RecordPlay.vue?vue&type=script&lang=ts&"
export * from "./RecordPlay.vue?vue&type=script&lang=ts&"
import style0 from "./RecordPlay.vue?vue&type=style&index=0&id=6fb6ae5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb6ae5e",
  null
  
)

export default component.exports